<template>
  <div class="chartWarp userWarp">
    <div class="pure-g user-row1">
      <div class="pure-u-7-24 col2">
        <div class="chartBlock">
          <div class="hd">
            <div class="chartTit">
              <h2 class="titContent">lolita·JK·HanFu新增趋势</h2>
            </div>
          </div>
          <div class="bd">
            <div id="lossGrowth" class="chartDiv"></div>
          </div>
        </div>

        <div class="chartBlock">
          <div class="hd">
            <div class="chartTit">
              <h2 class="titContent">lolita·JK·HanFu收藏数</h2>
            </div>
          </div>
          <div class="bd">
            <div id="cSorNum" class="chartDiv"></div>
          </div>
        </div>
      </div>

      <div class="pure-u-10-24">
        <div class="chartBlock">
          <div class="hd">
            <div class="chartTit">
              <h2 class="titContent">🌸今天上班也要开心🌸</h2>
            </div>
          </div>
          <div class="bd">
            <div id="earth" class="chartDiv"></div>
          </div>
        </div>
      </div>

      <!-- lolita·JK·HanFu色系选择 -->
      <div class="pure-u-7-24 col2">
        <div class="chartBlock">
          <div class="hd">
            <div class="chartTit">
              <h2 class="titContent">lolita·JK·HanFu色系选择</h2>
            </div>
          </div>
          <div class="bd">
            <div id="pInterval" class="chartDiv"></div>
          </div>
        </div>

        <!-- 性别分布 -->
        <div class="chartBlock">
          <div class="hd">
            <div class="chartTit">
              <h2 class="titContent">各性别分布购买情况</h2>
            </div>
          </div>
          <div class="bd">
            <div id="expLoc" class="chartDiv"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 动态数据监测 -->
    <div class="pure-g user-row2">
      <div class="pure-u-12-24">
        <div class="chartBlock">
          <div class="hd">
            <div class="chartTit">
              <h2 class="titContent">lolita·JK·HanFu配饰搭配动态数据监测</h2>
            </div>
          </div>
          <div class="bd">
            <div id="expTime" class="chartDiv"></div>
          </div>
        </div>
      </div>


    </div>
    <!-- 底部波浪效果 -->
    <div class="bolang">
      <div class="waveWrapper waveAnimation">
        <div class="waveWrapperInner bgTop">
          <div class="wave waveTop"></div>
        </div>
        <div class="waveWrapperInner bgMiddle">
          <div class="wave waveMiddle"></div>
        </div>
        <div class="waveWrapperInner bgBottom">
          <div class="wave waveBottom"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import * as echarts from './js/echarts.js'
import './js/three.js'
import { startSnow, stopSnow } from './js/xuehua.js'

// 雪花粒子贴图（由 webpack 处理资源路径，避免运行时 404）
import snowImg1 from './img/151375665240370100.png'
import snowImg2 from './img/151375668550091372.png'
import snowImg3 from './img/151375669416355455.png'
import snowImg4 from './img/151375670204115466.png'
import snowImg5 from './img/151375671039447316.png'

// ===== 炫彩渐变配置 =====
function lGrad(stops) {
  return new echarts.graphic.LinearGradient(0, 0, 0, 1, stops)
}
function rGrad(stops) {
  return new echarts.graphic.RadialGradient(0.5, 0.5, 1, stops)
}
const VIBRANT = {
  sakura: lGrad([{ offset: 0, color: '#ffd9e6' }, { offset: 1, color: '#f68fa8' }]),
  apricot: lGrad([{ offset: 0, color: '#fff3d8' }, { offset: 1, color: '#ffc481' }]),
  mint: lGrad([{ offset: 0, color: '#d9f6e9' }, { offset: 1, color: '#55c79b' }]),
  sky: lGrad([{ offset: 0, color: '#d9ecff' }, { offset: 1, color: '#66b0f0' }]),
  lavender: lGrad([{ offset: 0, color: '#e7daff' }, { offset: 1, color: '#a48cf0' }]),
  rose: lGrad([{ offset: 0, color: '#ffd3df' }, { offset: 1, color: '#f57e9f' }]),
  candy: lGrad([
    { offset: 0, color: '#ffd6e4' },
    { offset: 0.25, color: '#f7a8c4' },
    { offset: 0.5, color: '#b8a7f0' },
    { offset: 0.75, color: '#7ec8f0' },
    { offset: 1, color: '#ffd9a0' }
  ])
}
export default {
  name: 'LolitaData',
  data() {
    return {
      charts: {},
      timers: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initPInterval()
      this.initLossGrowth()
      this.initCSorNum()
      this.initEarth()
      this.initExpLoc()
      this.initExpTime()
      this.initResize()
      // 启动雪花飘落效果
      startSnow({ images: [snowImg1, snowImg2, snowImg3, snowImg4, snowImg5] })
    })
  },
  beforeDestroy() {
    // 恢复全局滚动：进入本页时 reset.css 曾锁定 body 滚动，防止样式残留导致登录页无法下滑
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
    // 停止雪花效果并清理
    stopSnow()
    // 清理定时器
    this.timers.forEach(timer => clearInterval(timer))
    this.timers = []
    // 销毁图表实例
    Object.values(this.charts).forEach(chart => {
      if (chart && !chart.isDisposed()) {
        chart.dispose()
      }
    })
    this.charts = {}
    window.removeEventListener('resize', this.handleResize)
    // 断开容器尺寸监听
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  methods: {
    // ========== lolita·JK·HanFu色系选择（玫瑰图） ==========
    initPInterval() {
      const dom = document.getElementById('pInterval')
      if (!dom) return
      const chart = echarts.init(dom)
      this.charts.pInterval = chart

      const roseColors = [
        ['#ffd9e6', '#f68fa8'],
        ['#ffe9cf', '#ffc07a'],
        ['#fff6d4', '#ffdf70'],
        ['#d5f6e6', '#5bc99d'],
        ['#d8ecff', '#66b0f0'],
        ['#e7daff', '#a48cf0']
      ]
      const option = {
        legend: {
          top: 'bottom',
          icon: 'circle',
          itemWidth: 15,
          itemHeight: 15,
          itemGap: 14,
          textStyle: { fontSize: 12 }
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        series: [
          {
            name: 'Nightingale Chart',
            type: 'pie',
            radius: [14, 80],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 6,
              // borderColor: '#fff',
              // borderWidth: 2
            },
            label: { fontSize: 11, color: '#333' },
            labelLine: { length: 8, length2: 6 },
            data: [
              { value: 40, name: '淡粉色' },
              { value: 38, name: '淡蓝色' },
              { value: 32, name: '草若色' },
              { value: 30, name: '淡紫色' },
              { value: 28, name: '淡黄色' },
              { value: 26, name: '淡红色' }
            ].map((item, i) => ({
              ...item,
              itemStyle: {
                color: rGrad([
                  { offset: 0, color: roseColors[i][0] },
                  { offset: 1, color: roseColors[i][1] }
                ])
              }
            }))
          }
        ]
      }
      chart.setOption(option)
    },

    // ========== lolita·JK·HanFu新增趋势（极坐标柱图） ==========
    initLossGrowth() {
      const dom = document.getElementById('lossGrowth')
      if (!dom) return
      const chart = echarts.init(dom)
      this.charts.lossGrowth = chart

      const option = {
        angleAxis: {
          axisLine: { lineStyle: { color: 'rgba(86,86,86,0.78)' } },
          splitLine: { lineStyle: { color: 'rgba(86,86,86,0.78)' } }
        },
        radiusAxis: {
          type: 'category',
          data: ['男孩' ,'女孩', '女孩', '男孩'],
          z: 10,
          axisLabel: { fontSize: 11 }
        },
        polar: {
          center: ['50%', '47%'],
          radius: ['8%', '68%']
        },
        series: [
          {
            type: 'bar',
            data: [1, 2, 3, 4],
            coordinateSystem: 'polar',
            name: '女孩',
            stack: 'a',
            itemStyle: { color: VIBRANT.sakura, borderRadius: 6 },
            emphasis: {
              focus: 'series'
            }
          },
          {
            type: 'bar',
            data: [2, 4, 6, 8],
            coordinateSystem: 'polar',
            name: '男孩',
            stack: 'a',
            itemStyle: { color: VIBRANT.sky, borderRadius: 6 },
            emphasis: {
              focus: 'series'
            }
          },
          {
            type: 'bar',
            data: [1, 2, 3, 4],
            coordinateSystem: 'polar',
            name: 'Lolita·JK·HanFu',
            stack: 'a',
            itemStyle: { color: VIBRANT.lavender, borderRadius: 6 },
            emphasis: {
              focus: 'series'
            }
          }
        ],
        legend: {
          show: true,
          data: ['女孩','男孩','Lolita·JK·HanFu'],
          bottom: 6,
          icon: 'circle',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: { fontSize: 12 }
        }
      };

      option && chart.setOption(option);
    },

    // ========== lolita·JK·HanFu收藏数（动态柱线图） ==========
    initCSorNum() {
      const dom = document.getElementById('cSorNum')
      if (!dom) return
      const chart = echarts.init(dom)
      this.charts.cSorNum = chart

      const categoriesA = (function () {
        let now = new Date()
        let res = []
        let len = 10
        while (len--) {
          res.unshift(now.toLocaleTimeString().replace(/^\D*/, ''))
          now = new Date(+now - 2000)
        }
        return res
      })()
      const categoriesB = (function () {
        let res = []
        let len = 10
        while (len--) {
          res.push(10 - len - 1)
        }
        return res
      })()
      const data = (function () {
        let res = []
        let len = 10
        while (len--) {
          res.push(Math.round(Math.random() * 1000))
        }
        return res
      })()
      const data2 = (function () {
        let res = []
        let len = 0
        while (len < 10) {
          res.push(+(Math.random() * 10 + 5).toFixed(1))
          len++
        }
        return res
      })()

      const option = {
        title: {
          text: 'Lolita Data',
          textStyle: { fontSize: 12, color: '#666' },
          top: 4,
          left: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: { backgroundColor: '#283b56' }
          }
        },
        legend: {
          top: 6,
          icon: 'circle',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: { fontSize: 12 }
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        },
        dataZoom: { show: false, start: 0, end: 100 },
        grid: { top: 42, left: 55, right: 55, bottom: 28 },
        xAxis: [
          { type: 'category', boundaryGap: true, data: categoriesA },
          { type: 'category', boundaryGap: true, data: categoriesB }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: 'Price',
            max: 30,
            min: 0,
            boundaryGap: [0.2, 0.2],
            nameTextStyle: { fontSize: 11 }
          },
          {
            type: 'value',
            scale: true,
            name: 'Order',
            max: 1200,
            min: 0,
            boundaryGap: [0.2, 0.2],
            nameTextStyle: { fontSize: 11 }
          }
        ],
        series: [
          {
            name: '线下关注',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data,
            barWidth: '55%',
            itemStyle: {
              color: VIBRANT.sky,
              borderRadius: [4, 4, 0, 0]
            }
          },
          {
            name: '线上关注',
            type: 'line',
            data: data2,
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            itemStyle: { color: '#f57e9f' },
            lineStyle: { width: 2.5, color: '#f57e9f' },
            areaStyle: {
              color: lGrad([
                { offset: 0, color: 'rgba(245,126,159,.35)' },
                { offset: 1, color: 'rgba(245,126,159,0)' }
              ])
            }
          }
        ]
      }

      let appCount = 11
      const timer = setInterval(() => {
        let axisData = new Date().toLocaleTimeString().replace(/^\D*/, '')
        data.shift()
        data.push(Math.round(Math.random() * 1000))
        data2.shift()
        data2.push(+(Math.random() * 10 + 5).toFixed(1))
        categoriesA.shift()
        categoriesA.push(axisData)
        categoriesB.shift()
        categoriesB.push(appCount++)
        chart.setOption({
          xAxis: [
            { data: categoriesA },
            { data: categoriesB }
          ],
          series: [
            { data: data },
            { data: data2 }
          ]
        })
      }, 2100)
      this.timers.push(timer)

      chart.setOption(option)
    },

    // ========== 今天上班也要开心 ==========
    initEarth() {
      const dom = document.getElementById('earth')
      if (!dom) return
      const chart = echarts.init(dom)
      this.charts.earth = chart

      var dataMap = {}

      function dataFormatter(obj) {
        var pList = [
          '北京', '天津', '河北', '山西', '辽宁', '吉林', '上海', '江苏',
          '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西',
          '海南', '重庆', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆'
        ]
        var temp
        for (var year = 2017; year <= 2026; year++) {
          var max = 0
          var sum = 0
          temp = obj[year]
          for (var i = 0, l = temp.length; i < l; i++) {
            max = Math.max(max, temp[i])
            sum += temp[i]
            obj[year][i] = {
              name: pList[i],
              value: temp[i]
            }
          }
          obj[year + 'max'] = Math.floor(max / 100) * 100
          obj[year + 'sum'] = sum
        }
        return obj
      }

      dataMap.dataGDP = dataFormatter({
        2026: [16251.93, 11307.28, 24515.76, 11237.55, 14359.88, 22226.7, 10568.83, 12582, 19195.69, 49110.27, 32318.85, 15300.65, 17560.18, 11702.82, 45361.85, 26931.03, 19632.26, 19669.56, 53210.28, 11720.87, 2522.66, 10011.37, 21026.68, 5701.84, 8893.12, 605.83, 12512.3, 5020.37,  6610.05],
        2025: [14113.58, 9224.46, 20394.26, 9200.86, 11672, 18457.27, 8667.58, 10368.6, 17165.98, 41425.48, 27722.31, 12359.33, 14737.12, 9451.26, 39169.92, 23092.36, 15967.61, 16037.96, 46013.06, 9569.85, 2064.5, 7925.58, 17185.48, 4602.16, 7224.18, 507.46, 10123.48, 4120.75,  5437.47],
        2024: [12153.03, 7521.85, 17235.48, 7358.31, 9740.25, 15212.49, 7278.75, 8587, 15046.45, 34457.3, 22990.35, 10062.82, 12236.53, 7655.18, 33896.65, 19480.46, 12961.1, 13059.69, 39482.56, 7759.16, 1654.21, 6530.01, 14151.28, 3912.68, 6169.75, 441.36, 8169.8, 3387.56,  4277.05],
        2023: [11115, 6719.01, 16011.97, 7315.4, 8496.2, 13668.58, 6426.1, 8314.37, 14069.87, 30981.98, 21462.69, 8851.66, 10823.01, 6971.05, 30933.28, 18018.53, 11328.92, 11555, 36796.71, 7021, 1503.06, 5793.66, 12601.23, 3561.56, 5692.12, 394.85, 7314.58, 3166.82,  4183.21],
        2022: [9846.81, 5252.76, 13607.32, 6024.45, 6423.18, 11164.3, 5284.69, 7104, 12494.01, 26018.48, 18753.73, 7360.92, 9248.53, 5800.25, 25776.91, 15012.46, 9333.4, 9439.6, 31777.01, 5823.41, 1254.17, 4676.13, 10562.39, 2884.11, 4772.52, 341.43, 5757.29, 2703.98,  3523.16],
        2021: [8117.78, 4462.74, 11467.6, 4878.61, 4944.25, 9304.52, 4275.12, 6211.8, 10572.24, 21742.05, 15718.47, 6112.5, 7583.85, 4820.53, 21900.19, 12362.79, 7617.47, 7688.67, 26587.76, 4746.16, 1065.67, 3907.23, 8690.24, 2338.98, 3988.14, 290.76, 4743.61, 2277.35,  3045.26],
        2020: [6969.52, 3905.64, 10012.11, 4230.53, 3905.03, 8047.26, 3620.27, 5513.7, 9247.66, 18598.69, 13417.68, 5350.17, 6554.69, 4056.76, 18366.87, 10587.42, 6590.19, 6596.1, 22557.37, 3984.1, 918.75, 3467.72, 7385.1, 2005.42, 3462.73, 248.8, 3933.72,  612.61, 2604.19],
        2019: [6033.21, 3110.97, 8477.63, 3571.37, 3041.07, 6672, 3122.01, 4750.6, 8072.83, 15003.6, 11648.7, 4759.3, 5763.35, 3456.7, 15021.84, 8553.79, 5633.24, 5641.94, 18864.62, 3433.5, 819.66, 3034.58, 6379.63, 1677.8, 3081.91, 220.34, 3175.58,  537.11, 2209.09],
        2018: [5007.21, 2578.03, 6921.29, 2855.23, 2388.38, 6002.54, 2662.08, 4057.4, 6694.23, 12442.87, 9705.02, 3923.11, 4983.67, 2807.41, 12078.15, 6867.7, 4757.45, 4659.99, 15844.64, 2821.11, 713.96, 2555.72, 5333.09, 1426.34, 2556.02, 185.09, 2587.72,  445.36, 1886.35],
        2017: [4315, 2150.76, 6018.28, 2324.8, 1940.94, 5458.22, 2348.54, 3637.2, 5741.03, 10606.85, 8003.67, 3519.72, 4467.55, 2450.48, 10275.5, 6035.48, 4212.82, 4151.54, 13502.42, 2523.73, 642.73, 2232.86, 4725.01, 1243.43, 2312.82, 162.04, 2253.39,  377.16, 1612.6]
      })

      dataMap.dataPI = dataFormatter({
        2026: [136.27, 159.72, 2905.73, 641.42, 1306.3, 1915.57, 1277.44, 1701.5, 124.94, 3064.78, 1583.04, 2015.31, 1612.24, 1391.07, 3973.85, 3512.24, 2569.3, 2768.03, 2665.2, 2047.23, 659.23, 844.52, 2983.51, 726.22, 1411.01, 74.47, 1220.9, 678.75,  1139.03],
        2025: [124.36, 145.58, 2562.81, 554.48, 1095.28, 1631.08, 1050.15, 1302.9, 114.15, 2540.1, 1360.56, 1729.02, 1363.67, 1206.98, 3588.28, 3258.09, 2147, 2325.5, 2286.98, 1675.06, 539.83, 685.38, 2482.89, 625.03, 1108.38, 68.72, 988.45, 599.28, 1078.63],
        2024: [118.29, 128.85, 2207.34, 477.59, 929.6, 1414.9, 980.57, 1154.33, 113.82, 2261.86, 1163.08, 1495.45, 1182.74, 1098.66, 3226.64, 2769.05, 1795.9, 1969.69, 2010.27, 1458.49, 462.19, 606.8, 2240.61, 550.27, 1067.6, 63.88, 789.64, 497.05,  759.74],
        2023: [112.83, 122.58, 2034.59, 313.58, 907.95, 1302.02, 916.72, 1088.94, 111.8, 2100.11, 1095.96, 1418.09, 1158.17, 1060.38, 3002.65, 2658.78, 1780, 1892.4, 1973.05, 1453.75, 436.04, 575.4, 2216.15, 539.19, 1020.56, 60.62, 753.72, 462.27,  691.07],
        2022: [101.26, 110.19, 1804.72, 311.97, 762.1, 1133.42, 783.8, 915.38, 101.84, 1816.31, 986.02, 1200.18, 1002.11, 905.77, 2509.14, 2217.66, 1378, 1626.48, 1695.57, 1241.35, 361.07, 482.39, 2032, 446.38, 837.35, 54.89, 592.63, 387.55,  628.72],
        2021: [88.8, 103.35, 1461.81, 276.77, 634.94, 939.43, 672.76, 750.14, 93.81, 1545.05, 925.1, 1011.03, 865.98, 786.14, 2138.9, 1916.74, 1140.41, 1272.2, 1532.17, 1032.47, 323.48, 386.38, 1595.48, 382.06, 724.4, 50.9, 484.81, 334,  527.8],
        2020: [88.68, 112.38, 1400, 262.42, 589.56, 882.41, 625.61, 684.6, 90.26, 1461.51, 892.83, 966.5, 827.36, 727.37, 1963.51, 1892.01, 1082.13, 1100.65, 1428.27, 912.5, 300.75, 463.4, 1481.14, 368.94, 661.69, 48.04, 435.77, 308.06,  509.99],
        2019: [87.36, 105.28, 1370.43, 276.3, 522.8, 798.43, 568.69, 605.79, 83.45, 1367.58, 814.1, 950.5, 786.84, 664.5, 1778.45, 1649.29, 1020.09, 1022.45, 1248.59, 817.88, 278.76, 428.05, 1379.93, 334.5, 607.75, 44.3, 387.88,  65.33, 461.26],
        2018: [84.11, 89.91, 1064.05, 215.19, 420.1, 615.8, 488.23, 504.8, 81.02, 1162.45, 717.85, 749.4, 692.94, 560, 1480.67, 1198.7, 798.35, 886.47, 1072.91, 658.78, 244.29, 339.06, 1128.61, 298.69, 494.6, 40.7, 302.66, 237.91,  412.9],
        2017: [82.44, 84.21, 956.84, 197.8, 374.69, 590.2, 446.17, 474.2, 79.68, 1110.44, 685.2, 783.66, 664.78, 535.98, 1390, 1288.36, 707, 847.25, 1015.08, 601.99, 222.89, 317.87, 1047.95, 281.1, 463.44, 39.75, 282.21, 215.51,  305]
      })

      dataMap.dataSI = dataFormatter({
        2026: [3752.48, 5928.32, 13126.86, 6635.26, 8037.69, 12152.15, 5611.48, 5962.41, 7927.89, 25203.28, 16555.58, 8309.38, 9069.2, 6390.55, 24017.11, 15427.08, 9815.94, 9361.99, 26447.38, 5675.32, 714.5, 5543.04, 11029.13, 2194.33, 3780.32, 208.79, 6935.59, 2377.83,  3225.9],
        2025: [3388.38, 4840.23, 10707.68, 5234, 6367.69, 9976.82, 4506.31, 5025.15, 7218.32, 21753.93, 14297.93, 6436.62, 7522.83, 5122.88, 21238.49, 13226.38, 7767.24, 7343.19, 23014.53, 4511.68, 571, 4359.12, 8672.18, 1800.06, 3223.49, 163.92, 5446.1, 1984.97,  2592.15],
        2024: [2855.55, 3987.84, 8959.83, 3993.8, 5114, 7906.34, 3541.92, 4060.72, 6001.78, 18566.37, 11908.49, 4905.22, 6005.3, 3919.45, 18901.83, 11010.5, 6038.08, 5687.19, 19419.7, 3381.54, 443.43, 3448.77, 6711.87, 1476.62, 2582.53, 136.63, 4236.42, 1527.24,  1929.59],
        2023: [2626.41, 3709.78, 8701.34, 4242.36, 4376.19, 7158.84, 3097.12, 4319.75, 6085.84, 16993.34, 11567.42, 4198.93, 5318.44, 3554.81, 17571.98, 10259.99, 5082.07, 5028.93, 18502.2, 3037.74, 423.55, 3057.78, 5823.39, 1370.03, 2452.75, 115.56, 3861.12, 1470.34,  2070.76],
        2022: [2509.4, 2892.53, 7201.88, 3454.49, 3193.67, 5544.14, 2475.45, 3695.58, 5571.06, 14471.26, 10154.25, 3370.96, 4476.42, 2975.53, 14647.53, 8282.83, 4143.06, 3977.72, 16004.61, 2425.29, 364.26, 2368.53, 4648.79, 1124.79, 2038.39, 98.48, 2986.46, 1279.32,  1647.55],
        2021: [2191.43, 2457.08, 6110.43, 2755.66, 2374.96, 4566.83, 1915.29, 3365.31, 4969.95, 12282.89, 8511.51, 2711.18, 3695.04, 2419.74, 12574.03, 6724.61, 3365.08, 3187.05, 13469.77, 1878.56, 308.62, 1871.65, 3775.14, 967.54, 1705.83, 80.1, 2452.44, 1043.19,  1459.3],
        2020: [2026.51, 2135.07, 5271.57, 2357.04, 1773.21, 3869.4, 1580.83, 2971.68, 4381.2, 10524.96, 7164.75, 2245.9, 3175.92, 1917.47, 10478.62, 5514.14, 2852.12, 2612.57, 11356.6, 1510.68, 240.83, 1564, 3067.23, 821.16, 1426.42, 63.52, 1951.36, 838.56,  1164.79],
        2019: [1853.58, 1685.93, 4301.73, 1919.4, 1248.27, 3061.62, 1329.68, 2487.04, 3892.12, 8437.99, 6250.38, 1844.9, 2770.49, 1566.4, 8478.69, 4182.1, 2320.6, 2190.54, 9280.73, 1253.7, 205.6, 1376.91, 2489.4, 681.5, 1281.63, 52.74, 1553.1, 713.3,  914.47],
        2018: [1487.15, 1337.31, 3417.56, 1463.38, 967.49, 2898.89, 1098.37, 2084.7, 3209.02, 6787.11, 5096.38, 1535.29, 2340.82, 1204.33, 6485.05, 3310.14, 1956.02, 1777.74, 7592.78, 984.08, 175.82, 1135.31, 2014.8, 569.37, 1047.66, 47.64, 1221.17, 572.02,  719.54],
        2017: [1249.99, 1069.08, 2911.69, 1134.31, 754.78, 2609.85, 943.49, 1843.6, 2622.45, 5604.49, 4090.48, 1337.04, 2036.97, 941.77, 5184.98, 2768.75, 1709.89, 1523.5, 6143.4, 846.89, 148.88, 958.87, 1733.38, 481.96, 934.88, 32.72, 1007.56, 501.69,  603.15]
      })

      dataMap.dataTI = dataFormatter({
        2026: [12363.18, 5219.24, 8483.17, 3960.87, 5015.89, 8158.98, 3679.91, 4918.09, 11142.86, 20842.21, 14180.23, 4975.96, 6878.74, 3921.2, 17370.89, 7991.72,  24097.7, 3998.33, 1148.93, 3623.81, 7014.04, 2781.29, 3701.79, 322.57, 4355.81, 1963.79, 540.18, 861.92, 2245.12],
        2025: [10600.84, 4238.65, 7123.77, 3412.38, 4209.03, 6849.37, 3111.12, 4040.55, 9833.51, 17131.45, 12063.82, 4193.69, 5850.62, 3121.4, 14343.14, 6607.89,  20711.55, 3383.11, 953.67, 2881.08, 6030.41, 2177.07, 2892.31, 274.82, 3688.93, 1536.5, 470.88, 702.45, 1766.69],
        2024: [9179.19, 3405.16, 6068.31, 2886.92, 3696.65, 5891.25, 2756.26, 3371.95, 8930.85, 13629.07, 9918.78, 3662.15, 5048.49, 2637.07, 11768.18, 5700.91,  18052.59, 2919.13, 748.59, 2474.44, 5198.8, 1885.79, 2519.62, 240.85, 3143.74, 1363.27, 398.54, 563.74, 1587.72],
        2023: [8375.76, 2886.65, 5276.04, 2759.46, 3212.06, 5207.72, 2412.26, 2905.68, 7872.23, 11888.53, 8799.31, 3234.64, 4346.4, 2355.86, 10358.64, 5099.76,  16321.46, 2529.51, 643.47, 2160.48, 4561.69, 1652.34, 2218.81, 218.67, 2699.74, 1234.21, 355.93, 475, 1421.38],
        2022: [7236.15, 2250.04, 4600.72, 2257.99, 2467.41, 4486.74, 2025.44, 2493.04, 6821.11, 9730.91, 7613.46, 2789.78, 3770, 1918.95, 8620.24, 4511.97, 3812.34, 2156.76, 528.84, 1825.21, 3881.6, 1312.94, 1896.78, 188.06, 2178.2, 1037.11, 294.91, 366.18, 1246.89],
        2021: [5837.55, 1902.31, 3895.36, 1846.18, 1934.35, 3798.26, 1687.07, 2096.35, 5508.48, 7914.11, 6281.86, 2390.29, 3022.83, 1614.65, 7187.26, 3721.44,  11585.82, 1835.12, 433.57, 1649.2, 3319.62, 989.38, 1557.91, 159.76, 1806.36, 900.16, 249.04, 294.78, 1058.16],
        2020: [4854.33, 1658.19, 3340.54, 1611.07, 1542.26, 3295.45, 1413.83, 1857.42, 4776.2, 6612.22, 5360.1, 2137.77, 2551.41, 1411.92, 5924.74, 3181.27,  9772.5, 1560.92, 377.17, 1440.32, 2836.73, 815.32, 1374.62, 137.24, 1546.59, 787.36, 213.37, 259.49, 929.41],
        2019: [4092.27, 1319.76, 2805.47, 1375.67, 1270, 2811.95, 1223.64, 1657.77, 4097.26, 5198.03, 4584.22, 1963.9, 2206.02, 1225.8, 4764.7, 2722.4, 2292.55,  1361.92, 335.3, 1229.62, 2510.3, 661.8, 1192.53, 123.3, 1234.6, 688.41, 193.7, 227.73, 833.36],
        2018: [3435.95, 1150.81, 2439.68, 1176.65, 1000.79, 2487.85, 1075.48, 1467.9, 3404.19, 4493.31, 3890.79, 1638.42, 1949.91, 1043.08, 4112.43, 2358.86,  7178.94, 1178.25, 293.85, 1081.35, 2189.68, 558.28, 1013.76, 96.76, 1063.89, 589.91, 169.81, 195.46, 753.91],
        2017: [2982.57, 997.47, 2149.75, 992.69, 811.47, 2258.17, 958.88, 1319.4, 3038.9, 3891.92, 3227.99, 1399.02, 1765.8, 972.73, 3700.52, 1978.37, 1795.93,  1074.85, 270.96, 956.12, 1943.68, 480.37, 914.5, 89.56, 963.62, 514.83, 148.83, 171.14, 704.5]
      })

      dataMap.dataEstate = dataFormatter({
        2026: [1074.93, 411.46, 918.02, 224.91,  238.61, 492.1, 1019.68, 2747.89, 1677.13, 634.92, 911.16, 402.51, 1838.14, 987, 634.67, 518.04, 3321.31, 465.68, 208.71, 396.28, 620.62, 160.3, 222.31, 17.44, 398.03, 134.25, 29.05, 79.01, 176.22],
        2025: [1006.52, 377.59, 697.79, 192,  212.32, 391.89, 1002.5, 2600.95, 1618.17, 532.17, 679.03, 340.56, 1622.15, 773.23, 564.41, 464.21, 2813.95, 405.79, 188.33, 266.38, 558.56, 139.64, 223.45, 14.54, 315.95, 110.02, 25.41, 60.53, 143.44],
        2024: [1062.47, 308.73, 612.4, 173.31, 286.65, 605.27, 200.14, 301.18, 1237.56, 2025.39, 1316.84, 497.94, 656.61, 305.9, 1329.59, 622.98, 546.11, 400.11, 2470.63, 348.98, 121.76, 229.09, 548.14, 136.15, 205.14, 13.28, 239.92, 101.37, 23.05],
        2023: [844.59, 227.88, 513.81, 166.04, 273.3, 244.47, 939.34, 1626.13, 1052.03, 431.27, 506.98, 281.96, 1104.95, 512.42, 526.88, 340.07, 2057.45, 282.96, 95.6, 191.21, 453.63, 104.81, 195.48, 15.08, 193.27, 93.8, 19.96, 38.85, 89.79],
        2022: [821.5, 183.44, 467.97, 134.12, 191.01,  225.81, 958.06, 1365.71, 981.42, 366.57, 511.5, 225.96, 953.69, 447.44, 409.65, 301.8, 2029.77, 239.45, 67.19, 196.06, 376.84, 93.19, 193.59, 13.24, 153.98, 83.52, 16.98, 29.49, 91.28],
        2021: [658.3, 156.64, 397.14, 117.01, 136.5,  194.7, 773.61, 1017.91, 794.41, 281.98, 435.22, 184.67, 786.51, 348.7, 294.73, 254.81, 1722.07, 192.2, 44.45, 158.2, 336.2, 80.24, 165.92, 11.92, 125.2, 73.21, 15.17, 25.53, 68.9],
        2020: [493.73, 122.67, 330.87, 106, 98.75, 256.77,  715.97, 799.73, 688.86, 231.66, 331.8, 171.88, 664.9, 298.19, 217.17, 215.63, 1430.37, 165.05, 38.2, 143.88, 286.23, 76.38, 148.69, 10.02, 108.62, 63.78, 14.1, 22.97, 55.79],
        2019: [436.11, 106.14, 231.08, 95.1, 73.81, 203.1,  666.3, 534.17, 587.83, 188.28, 248.44, 167.2, 473.27, 236.44, 204.8, 191.5, 1103.75, 122.52, 30.64, 129.12, 264.3, 68.3, 116.54, 5.8, 95.9, 56.84, 13, 20.78, 53.55],
        2018: [341.88, 92.31, 185.19, 78.73,  91.99, 127.2, 487.82, 447.47, 473.16, 162.63, 215.84, 138.02, 418.21, 217.58, 176.8, 186.49, 955.66, 100.93, 25.14, 113.69, 231.72, 59.86, 103.79, 4.35, 83.9, 48.09, 11.41, 16.85, 47.84],
        2017: [298.02, 73.04, 140.89, 65.83,  76.11, 118.7, 384.86, 371.09, 360.63, 139.18, 188.09, 125.27, 371.13, 199.31, 145.17, 165.29, 808.16, 82.83, 21.45, 90.48, 210.82, 53.49, 95.68, 3.42, 77.68, 41.52, 9.74, 13.46, 43.04]
      })

      dataMap.dataFinancial = dataFormatter({
        2026: [2215.41, 756.5, 746.01, 519.32,  207.65, 370.78, 2277.4, 2600.11, 2730.29, 503.85, 862.41, 357.44, 1640.41, 868.2, 674.57, 501.09, 2916.13, 445.37, 105.24, 704.66, 868.15, 297.27, 456.23, 31.7, 432.11, 145.05, 62.56, 134.18, 288.77],
        2025: [1863.61, 572.99, 615.42, 448.3,  190.12, 304.59, 1950.96, 2105.92, 2326.58, 396.17, 767.58, 241.49, 1361.45, 697.68, 561.27, 463.16, 2658.76, 384.53, 78.12, 496.56, 654.7, 231.51, 375.08, 27.08, 384.75, 100.54, 54.53, 97.87, 225.2],
        2024: [1603.63, 461.2, 525.67, 361.64, 180.83, 227.54, 1804.28, 1596.98, 1899.33, 359.6, 612.2, 165.1, 1044.9, 499.92, 479.11, 402.57, 2283.29, 336.82, 65.73, 389.97, 524.63, 194.44, 351.74, 23.17, 336.21, 88.27, 45.63, 75.54, 198.87],
        2023: [1519.19, 368.1, 420.74, 290.91,  147.24, 177.43, 1414.21, 1298.48, 1653.45, 313.81, 497.65, 130.57, 880.28, 413.83, 393.05, 334.32, 1972.4, 249.01, 47.33, 303.01, 411.14, 151.55, 277.66, 22.42, 287.16, 72.49, 36.54, 64.8, 171.97],
        2022: [1302.77, 288.17, 347.65, 218.73,  126.03, 155.48, 1209.08, 1054.25, 1251.43, 223.85, 385.84, 101.34, 734.9, 302.31, 337.27, 260.14, 1705.08, 190.73, 34.43, 247.46, 359.11, 122.25, 168.55, 11.51, 231.03, 61.6, 27.67, 51.05, 149.22],
        2021: [982.37, 186.87, 284.04, 169.63,  100.75, 74.17, 825.2, 653.25, 906.37, 166.01, 243.9, 79.75, 524.94, 219.72, 174.99, 204.72, 899.91, 129.14, 16.37, 213.7, 299.5, 89.43, 143.62, 6.44, 152.25, 50.51, 23.69, 36.99, 99.25],
        2020: [840.2, 147.4, 213.47, 135.07,  83.63, 35.03, 675.12, 492.4, 686.32, 127.05, 186.12, 69.55, 448.36, 181.74, 127.32, 162.37, 661.81, 91.93, 13.16, 185.18, 262.26, 73.67, 130.5, 7.57, 127.58, 44.73, 20.36, 32.25, 80.34],
        2019: [713.79, 136.97, 209.1, 110.29,  77.17, 32.2, 612.45, 440.5, 523.49, 94.1, 171, 65.1, 343.37, 170.82, 118.85, 118.64, 602.68, 74, 11.56, 162.38, 236.5, 60.3, 118.4, 5.4, 90.1, 42.99, 19, 27.92, 70.3],
        2018: [635.56, 112.79, 199.87, 118.48,  73.15, 32.2, 517.97, 392.11, 451.54, 87.45, 150.09, 64.31, 329.71, 165.11, 107.31, 99.35, 534.28, 61.59, 10.68, 147.04, 206.24, 48.01, 105.48, 4.74, 77.87, 42.31, 17.98, 24.8, 64.92],
        2017: [561.91, 76.86, 179.6, 124.1, 48.39,  31.6, 485.25, 368.86, 347.53, 81.85, 138.28, 76.51, 310.07, 158.77, 96.95, 92.43, 454.65, 35.86, 10.08, 134.52, 183.13, 41.45, 102.39, 2.81, 67.3, 42.08, 16.75, 21.45, 52.18]
      })

      const option = {
        baseOption: {
          timeline: {
            axisType: 'category',
            autoPlay: true,
            playInterval: 1000,
            data: [
              '2017-01-01',
              '2018-01-01',
              '2019-01-01',
              {
                value: '2020-01-01',
                tooltip: { formatter: '{b} Lolita达到一个高度' },
                symbol: 'diamond',
                symbolSize: 16
              },
              '2021-01-01',
              '2022-01-01',
              '2023-01-01',
              '2024-01-01',
              '2025-01-01',
              {
                value: '2026-01-01',
                tooltip: {
                  formatter: function (params) {
                    return params.name + 'Lolita达到又一个高度'
                  }
                },
                symbol: 'diamond',
                symbolSize: 18
              }
            ],
            label: {
              formatter: function (s) {
                return new Date(s).getFullYear()
              }
            }
          },
          // title: { subtext: '数据来自国家统计局' },
          tooltip: {},
          legend: {
            left: 'right',
            data: ['Lolita', 'JK制服', 'HanFu', '袜子', '高跟鞋', '配饰'],
            selected: {
              袜子: false,
              高跟鞋: false,
              配饰: false
            }
          },
          calculable: true,
          grid: {
            top: 58,
            bottom: 95,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value.replace('\n', '')
                  }
                }
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              axisLabel: { interval: 0 },
              data: [
                '北京', '\n天津', '河北', '\n山西', '辽宁', '\n吉林', '上海', '\n江苏',
                '浙江', '\n安徽', '福建', '\n江西', '山东', '\n河南', '湖北', '\n湖南', '广东', '\n广西',
                '海南', '\n重庆', '四川', '\n贵州', '云南', '\n西藏', '陕西', '\n甘肃', '青海', '\n宁夏','新疆',
              ],
              splitLine: { show: false }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: 'Lolita（亿元）'
            }
          ],
          series: [
            { name: '袜子', type: 'bar', itemStyle: { color: VIBRANT.sakura, borderRadius: [3, 3, 0, 0] } },
            { name: '高跟鞋', type: 'bar', itemStyle: { color: VIBRANT.apricot, borderRadius: [3, 3, 0, 0] } },
            { name: '配饰', type: 'bar', itemStyle: { color: VIBRANT.mint, borderRadius: [3, 3, 0, 0] } },
            { name: 'Lolita', type: 'bar', itemStyle: { color: VIBRANT.lavender, borderRadius: [3, 3, 0, 0] } },
            { name: 'JK制服', type: 'bar', itemStyle: { color: VIBRANT.sky, borderRadius: [3, 3, 0, 0] } },
            { name: 'HanFu', type: 'bar', itemStyle: { color: VIBRANT.rose, borderRadius: [3, 3, 0, 0] } },
            {
              name: 'Lolita占比',
              type: 'pie',
              center: ['75%', '35%'],
              radius: '28%',
              z: 100,
              color: ['#f68fa8', '#ffc481', '#55c79b'],
              // itemStyle: { borderColor: '#fff', borderWidth: 2 }
            }
          ]
        },
        options: [
          {
            title: { text: '2017全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2017'] },
              { data: dataMap.dataFinancial['2017'] },
              { data: dataMap.dataEstate['2017'] },
              { data: dataMap.dataPI['2017'] },
              { data: dataMap.dataSI['2017'] },
              { data: dataMap.dataTI['2017'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2017sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2017sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2017sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2018全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2018'] },
              { data: dataMap.dataFinancial['2018'] },
              { data: dataMap.dataEstate['2018'] },
              { data: dataMap.dataPI['2018'] },
              { data: dataMap.dataSI['2018'] },
              { data: dataMap.dataTI['2018'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2018sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2018sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2018sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2019全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2019'] },
              { data: dataMap.dataFinancial['2019'] },
              { data: dataMap.dataEstate['2019'] },
              { data: dataMap.dataPI['2019'] },
              { data: dataMap.dataSI['2019'] },
              { data: dataMap.dataTI['2019'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2019sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2019sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2019sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2020全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2020'] },
              { data: dataMap.dataFinancial['2020'] },
              { data: dataMap.dataEstate['2020'] },
              { data: dataMap.dataPI['2020'] },
              { data: dataMap.dataSI['2020'] },
              { data: dataMap.dataTI['2020'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2020sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2020sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2020sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2021全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2021'] },
              { data: dataMap.dataFinancial['2021'] },
              { data: dataMap.dataEstate['2021'] },
              { data: dataMap.dataPI['2021'] },
              { data: dataMap.dataSI['2021'] },
              { data: dataMap.dataTI['2021'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2021sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2021sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2021sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2022全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2022'] },
              { data: dataMap.dataFinancial['2022'] },
              { data: dataMap.dataEstate['2022'] },
              { data: dataMap.dataPI['2022'] },
              { data: dataMap.dataSI['2022'] },
              { data: dataMap.dataTI['2022'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2022sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2022sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2022sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2023全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2023'] },
              { data: dataMap.dataFinancial['2023'] },
              { data: dataMap.dataEstate['2023'] },
              { data: dataMap.dataPI['2023'] },
              { data: dataMap.dataSI['2023'] },
              { data: dataMap.dataTI['2023'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2023sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2023sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2023sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2024全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2024'] },
              { data: dataMap.dataFinancial['2024'] },
              { data: dataMap.dataEstate['2024'] },
              { data: dataMap.dataPI['2024'] },
              { data: dataMap.dataSI['2024'] },
              { data: dataMap.dataTI['2024'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2024sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2024sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2024sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2025全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2025'] },
              { data: dataMap.dataFinancial['2025'] },
              { data: dataMap.dataEstate['2025'] },
              { data: dataMap.dataPI['2025'] },
              { data: dataMap.dataSI['2025'] },
              { data: dataMap.dataTI['2025'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2025sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2025sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2025sum'] }
                ]
              }
            ]
          },
          {
            title: { text: '2026全国Lolita数据' },
            series: [
              { data: dataMap.dataGDP['2026'] },
              { data: dataMap.dataFinancial['2026'] },
              { data: dataMap.dataEstate['2026'] },
              { data: dataMap.dataPI['2026'] },
              { data: dataMap.dataSI['2026'] },
              { data: dataMap.dataTI['2026'] },
              {
                data: [
                  { name: 'Lolita', value: dataMap.dataPI['2026sum'] },
                  { name: 'JK制服', value: dataMap.dataSI['2026sum'] },
                  { name: 'HanFu', value: dataMap.dataTI['2026sum'] }
                ]
              }
            ]
          }
        ]
      }
      chart.setOption(option)
    },

    // ========== Lolita占比 ==========
    initExpLoc() {
      const dom = document.getElementById('expLoc')
      if (!dom) return
      const chart = echarts.init(dom)
      this.charts.expLoc = chart

      const femaleData = [
        [161.2, 51.6], [167.5, 59.0], [159.5, 49.2], [157.0, 63.0], [155.8, 53.6],
        [170.0, 59.0], [159.1, 47.6], [166.0, 69.8], [176.2, 66.8], [160.2, 75.2],
        [172.5, 55.2], [170.9, 54.2], [172.9, 62.5], [153.4, 42.0], [160.0, 50.0],
        [147.2, 49.8], [168.2, 49.2], [175.0, 73.2], [157.0, 47.8], [167.6, 68.8],
        [159.5, 50.6], [175.0, 82.5], [166.8, 57.2], [176.5, 87.8], [170.2, 72.8],
        [174.0, 54.5], [173.0, 59.8], [179.9, 67.3], [170.5, 67.8], [160.0, 47.0],
        [154.4, 46.2], [162.0, 55.0], [176.5, 83.0], [160.0, 54.4], [152.0, 45.8],
        [162.1, 53.6], [170.0, 73.2], [160.2, 52.1], [161.3, 67.9], [166.4, 56.6],
        [168.9, 62.3], [163.8, 58.5], [167.6, 54.5], [160.0, 50.2], [161.3, 60.3],
        [167.6, 58.3], [165.1, 56.2], [160.0, 50.2], [170.0, 72.9], [157.5, 59.8],
        [167.6, 61.0], [160.7, 69.1], [163.2, 55.9], [152.4, 46.5], [157.5, 54.3],
        [168.3, 54.8], [180.3, 60.7], [165.5, 60.0], [165.0, 62.0], [164.5, 60.3],
        [156.0, 52.7], [160.0, 74.3], [163.0, 62.0], [165.7, 73.1], [161.0, 80.0],
        [162.0, 54.7], [166.0, 53.2], [174.0, 75.7], [172.7, 61.1], [167.6, 55.7],
        [151.1, 48.7], [164.5, 52.3], [163.5, 50.0], [152.0, 59.3], [169.0, 62.5],
        [164.0, 55.7], [161.2, 54.8], [155.0, 45.9], [170.0, 70.6], [176.2, 67.2],
        [170.0, 69.4], [162.5, 58.2], [170.3, 64.8], [164.1, 71.6], [169.5, 52.8],
        [163.2, 59.8], [154.5, 49.0], [159.8, 50.0], [173.2, 69.2], [170.0, 55.9],
        [161.4, 63.4], [169.0, 58.2], [166.2, 58.6], [159.4, 45.7], [162.5, 52.2],
        [159.0, 48.6], [162.8, 57.8], [159.0, 55.6], [179.8, 66.8], [162.9, 59.4],
        [161.0, 53.6], [151.1, 73.2], [168.2, 53.4], [168.9, 69.0], [173.2, 58.4],
        [171.8, 56.2], [178.0, 70.6], [164.3, 59.8], [163.0, 72.0], [168.5, 65.2],
        [166.8, 56.6], [172.7, 105.2], [163.5, 51.8], [169.4, 63.4], [167.8, 59.0],
        [159.5, 47.6], [167.6, 63.0], [161.2, 55.2], [160.0, 45.0], [163.2, 54.0],
        [162.2, 50.2], [161.3, 60.2], [149.5, 44.8], [157.5, 58.8], [163.2, 56.4],
        [172.7, 62.0], [155.0, 49.2], [156.5, 67.2], [164.0, 53.8], [160.9, 54.4],
        [162.8, 58.0], [167.0, 59.8], [160.0, 54.8], [160.0, 43.2], [168.9, 60.5],
        [158.2, 46.4], [156.0, 64.4], [160.0, 48.8], [167.1, 62.2], [158.0, 55.5],
        [167.6, 57.8], [156.0, 54.6], [162.1, 59.2], [173.4, 52.7], [159.8, 53.2],
        [170.5, 64.5], [159.2, 51.8], [157.5, 56.0], [161.3, 63.6], [162.6, 63.2],
        [160.0, 59.5], [168.9, 56.8], [165.1, 64.1], [162.6, 50.0], [165.1, 72.3],
        [166.4, 55.0], [160.0, 55.9], [152.4, 60.4], [170.2, 69.1], [162.6, 84.5],
        [170.2, 55.9], [158.8, 55.5], [172.7, 69.5], [167.6, 76.4], [162.6, 61.4],
        [167.6, 65.9], [156.2, 58.6], [175.2, 66.8], [172.1, 56.6], [162.6, 58.6],
        [160.0, 55.9], [165.1, 59.1], [182.9, 81.8], [166.4, 70.7], [165.1, 56.8],
        [177.8, 60.0], [165.1, 58.2], [175.3, 72.7], [154.9, 54.1], [158.8, 49.1],
        [172.7, 75.9], [168.9, 55.0], [161.3, 57.3], [167.6, 55.0], [165.1, 65.5],
        [175.3, 65.5], [157.5, 48.6], [163.8, 58.6], [167.6, 63.6], [165.1, 55.2],
        [165.1, 62.7], [168.9, 56.6], [162.6, 53.9], [164.5, 63.2], [176.5, 73.6],
        [168.9, 62.0], [175.3, 63.6], [159.4, 53.2], [160.0, 53.4], [170.2, 55.0],
        [162.6, 70.5], [167.6, 54.5], [162.6, 54.5], [160.7, 55.9], [160.0, 59.0],
        [157.5, 63.6], [162.6, 54.5], [152.4, 47.3], [170.2, 67.7], [165.1, 80.9],
        [172.7, 70.5], [165.1, 60.9], [170.2, 63.6], [170.2, 54.5], [170.2, 59.1],
        [161.3, 70.5], [167.6, 52.7], [167.6, 62.7], [165.1, 86.3], [162.6, 66.4],
        [152.4, 67.3], [168.9, 63.0], [170.2, 73.6], [175.2, 62.3], [175.2, 57.7],
        [160.0, 55.4], [165.1, 104.1], [174.0, 55.5], [170.2, 77.3], [160.0, 80.5],
        [167.6, 64.5], [167.6, 72.3], [167.6, 61.4], [154.9, 58.2], [162.6, 81.8],
        [175.3, 63.6], [171.4, 53.4], [157.5, 54.5], [165.1, 53.6], [160.0, 60.0],
        [174.0, 73.6], [162.6, 61.4], [174.0, 55.5], [162.6, 63.6], [161.3, 60.9],
        [156.2, 60.0], [149.9, 46.8], [169.5, 57.3], [160.0, 64.1], [175.3, 63.6],
        [169.5, 67.3], [160.0, 75.5], [172.7, 68.2], [162.6, 61.4], [157.5, 76.8],
        [176.5, 71.8], [164.4, 55.5], [160.7, 48.6], [174.0, 66.4], [163.8, 67.3]
      ]

      const maleDeta = [
        [174.0, 65.6], [175.3, 71.8], [193.5, 80.7], [186.5, 72.6], [187.2, 78.8],
        [181.5, 74.8], [184.0, 86.4], [184.5, 78.4], [175.0, 62.0], [184.0, 81.6],
        [180.0, 76.6], [177.8, 83.6], [192.0, 90.0], [176.0, 74.6], [174.0, 71.0],
        [184.0, 79.6], [192.7, 93.8], [171.5, 70.0], [173.0, 72.4], [176.0, 85.9],
        [176.0, 78.8], [180.5, 77.8], [172.7, 66.2], [176.0, 86.4], [173.5, 81.8],
        [178.0, 89.6], [180.3, 82.8], [180.3, 76.4], [164.5, 63.2], [173.0, 60.9],
        [183.5, 74.8], [175.5, 70.0], [188.0, 72.4], [189.2, 84.1], [172.8, 69.1],
        [170.0, 59.5], [182.0, 67.2], [170.0, 61.3], [177.8, 68.6], [184.2, 80.1],
        [186.7, 87.8], [171.4, 84.7], [172.7, 73.4], [175.3, 72.1], [180.3, 82.6],
        [182.9, 88.7], [188.0, 84.1], [177.2, 94.1], [172.1, 74.9], [167.0, 59.1],
        [169.5, 75.6], [174.0, 86.2], [172.7, 75.3], [182.2, 87.1], [164.1, 55.2],
        [163.0, 57.0], [171.5, 61.4], [184.2, 76.8], [174.0, 86.8], [174.0, 72.2],
        [177.0, 71.6], [186.0, 84.8], [167.0, 68.2], [171.8, 66.1], [182.0, 72.0],
        [167.0, 64.6], [177.8, 74.8], [164.5, 70.0], [192.0, 101.6], [175.5, 63.2],
        [171.2, 79.1], [181.6, 78.9], [167.4, 67.7], [181.1, 66.0], [177.0, 68.2],
        [174.5, 63.9], [177.5, 72.0], [170.5, 56.8], [182.4, 74.5], [197.1, 90.9],
        [180.1, 93.0], [175.5, 80.9], [180.6, 72.7], [184.4, 68.0], [175.5, 70.9],
        [180.6, 72.5], [177.0, 72.5], [177.1, 83.4], [181.6, 75.5], [176.5, 73.0],
        [175.0, 70.2], [174.0, 73.4], [165.1, 70.5], [177.0, 68.9], [192.0, 102.3],
        [176.5, 68.4], [169.4, 65.9], [182.1, 75.7], [179.8, 84.5], [175.3, 87.7],
        [184.9, 86.4], [177.3, 73.2], [167.4, 53.9], [178.1, 72.0], [168.9, 55.5],
        [157.2, 58.4], [180.3, 83.2], [170.2, 72.7], [177.8, 64.1], [172.7, 72.3],
        [165.1, 65.0], [186.7, 86.4], [165.1, 65.0], [174.0, 88.6], [175.3, 84.1],
        [185.4, 66.8], [177.8, 75.5], [180.3, 93.2], [180.3, 82.7], [177.8, 58.0],
        [177.8, 79.5], [177.8, 78.6], [177.8, 71.8], [177.8, 116.4], [163.8, 72.2],
        [188.0, 83.6], [198.1, 85.5], [175.3, 90.9], [166.4, 85.9], [190.5, 89.1],
        [166.4, 75.0], [177.8, 77.7], [179.7, 86.4], [172.7, 90.9], [190.5, 73.6],
        [185.4, 76.4], [168.9, 69.1], [167.6, 84.5], [175.3, 64.5], [170.2, 69.1],
        [190.5, 108.6], [177.8, 86.4], [190.5, 80.9], [177.8, 87.7], [184.2, 94.5],
        [176.5, 80.2], [177.8, 72.0], [180.3, 71.4], [171.4, 72.7], [172.7, 84.1],
        [172.7, 76.8], [177.8, 63.6], [177.8, 80.9], [182.9, 80.9], [170.2, 85.5],
        [167.6, 68.6], [175.3, 67.7], [165.1, 66.4], [185.4, 102.3], [181.6, 70.5],
        [172.7, 95.9], [190.5, 84.1], [179.1, 87.3], [175.3, 71.8], [170.2, 65.9],
        [193.0, 95.9], [171.4, 91.4], [177.8, 81.8], [177.8, 96.8], [167.6, 69.1],
        [167.6, 82.7], [180.3, 75.5], [182.9, 79.5], [176.5, 73.6], [186.7, 91.8],
        [188.0, 84.1], [188.0, 85.9], [177.8, 81.8], [174.0, 82.5], [177.8, 80.5],
        [171.4, 70.0], [185.4, 81.8], [185.4, 84.1], [188.0, 90.5], [188.0, 91.4],
        [182.9, 89.1], [176.5, 85.0], [175.3, 69.1], [175.3, 73.6], [188.0, 80.5],
        [188.0, 82.7], [175.3, 86.4], [170.5, 67.7], [179.1, 92.7], [177.8, 93.6],
        [175.3, 70.9], [182.9, 75.0], [170.8, 93.2], [188.0, 93.2], [180.3, 77.7],
        [177.8, 61.4], [185.4, 94.1], [168.9, 75.0], [185.4, 83.6], [180.3, 85.5],
        [174.0, 73.9], [167.6, 66.8], [182.9, 87.3], [160.0, 72.3], [180.3, 88.6],
        [167.6, 75.5], [186.7, 101.4], [175.3, 91.1], [175.3, 67.3], [175.9, 77.7],
        [175.3, 81.8], [179.1, 75.5], [181.6, 84.5], [177.8, 76.6], [182.9, 85.0],
        [177.8, 102.5], [184.2, 77.3], [179.1, 71.8], [176.5, 87.9], [188.0, 94.3],
        [174.0, 70.9], [167.6, 64.5], [170.2, 77.3], [167.6, 72.3], [188.0, 87.3],
        [174.0, 80.0], [176.5, 82.3], [180.3, 73.6], [167.6, 74.1], [188.0, 85.9],
        [180.3, 73.2], [167.6, 76.3], [183.0, 65.9], [183.0, 90.9], [179.1, 89.1],
        [170.2, 62.3], [177.8, 82.7], [179.1, 79.1], [190.5, 98.2], [177.8, 84.1],
        [180.3, 83.2], [180.3, 83.2]
      ]

      function calculateAverage(data, dim) {
        let total = 0
        for (var i = 0; i < data.length; i++) {
          total += data[i][dim]
        }
        return (total /= data.length)
      }

      const scatterOption = {
        grid: { top: 18, left: 52, right: 25, bottom: 28 },
        xAxis: { scale: true, axisLabel: { fontSize: 11 } },
        yAxis: { scale: true, axisLabel: { fontSize: 11 } },
        series: [
          {
            type: 'scatter',
            id: 'female',
            data: femaleData,
            symbolSize: 7,
            itemStyle: {
              color: VIBRANT.rose,
              opacity: 0.8,
              shadowBlur: 6,
              shadowColor: 'rgba(245,126,159,.5)'
            }
          },
          {
            type: 'scatter',
            id: 'male',
            data: maleDeta,
            symbolSize: 7,
            itemStyle: {
              color: VIBRANT.sky,
              opacity: 0.8,
              shadowBlur: 6,
              shadowColor: 'rgba(102,176,240,.5)'
            }
          }
        ]
      }

      const barOption = {
        grid: { top: 18, left: 52, right: 25, bottom: 28 },
        xAxis: {
          type: 'category',
          data: ['小女孩', '小男孩'],
          axisLabel: { fontSize: 11 }
        },
        yAxis: { axisLabel: { fontSize: 11 } },
        series: [
          {
            type: 'bar',
            id: 'total',
            barWidth: '45%',
            data: [
              {
                value: calculateAverage(maleDeta, 0)
              },
              {
                value: calculateAverage(femaleData, 0)
              }
            ],
            itemStyle: {
              color: VIBRANT.lavender,
              borderRadius: [6, 6, 0, 0]
            }
          }
        ]
      }

      let currentOption = scatterOption
      const timer = setInterval(() => {
        currentOption = currentOption === scatterOption ? barOption : scatterOption
        chart.setOption(currentOption, true)
      }, 2000)
      this.timers.push(timer)

      chart.setOption(scatterOption)
    },

    // ========== Lolita（动态柱线） ==========
    initExpTime() {
      const dom = document.getElementById('expTime')
      if (!dom) return
      const chart = echarts.init(dom)
      this.charts.expTime = chart

      let count = 11
      const categories = (function () {
        let now = new Date()
        let res = []
        let len = 10
        while (len--) {
          res.unshift(now.toLocaleTimeString().replace(/^\D*/, ''))
          now = new Date(+now - 2000)
        }
        return res
      })()
      const categories2 = (function () {
        let res = []
        let len = 10
        while (len--) {
          res.push(10 - len - 1)
        }
        return res
      })()
      const data3 = (function () {
        let res = []
        let len = 10
        while (len--) {
          res.push(Math.round(Math.random() * 1000))
        }
        return res
      })()
      const data4 = (function () {
        let res = []
        let len = 0
        while (len < 10) {
          res.push(+(Math.random() * 10 + 5).toFixed(1))
          len++
        }
        return res
      })()

      const option = {
        title: {
          text: '动态数据监测',
          textStyle: { color: '#414141', fontSize: 12 },
          top: 4,
          left: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: { backgroundColor: '#283b56' }
          }
        },
        legend: {
          top: 6,
          icon: 'circle',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: { fontSize: 12 }
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        },
        dataZoom: { show: false, start: 0, end: 100 },
        grid: { top: 42, left: 55, right: 55, bottom: 28 },
        xAxis: [
          { type: 'category', boundaryGap: true, data: categories },
          { type: 'category', boundaryGap: true, data: categories2 }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: 'Price',
            max: 30,
            min: 0,
            boundaryGap: [0.2, 0.2],
            nameTextStyle: { fontSize: 11 }
          },
          {
            type: 'value',
            scale: true,
            name: 'Order',
            max: 1200,
            min: 0,
            boundaryGap: [0.2, 0.2],
            nameTextStyle: { fontSize: 11 }
          }
        ],
        series: [
          {
            name: 'Order',
            type: 'bar',
            xAxisIndex: 1,
            yAxisIndex: 1,
            barWidth: '55%',
            itemStyle: {
              normal: {
                barBorderRadius: [8, 8, 0, 0],
                color: VIBRANT.candy
              }
            },
            data: data3
          },
          {
            name: 'Price',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            itemStyle: { color: '#a48cf0' },
            lineStyle: { width: 2.5, color: '#a48cf0' },
            areaStyle: {
              color: lGrad([
                { offset: 0, color: 'rgba(164,140,240,.35)' },
                { offset: 1, color: 'rgba(164,140,240,0)' }
              ])
            },
            data: data4
          }
        ]
      }

      const timer = setInterval(() => {
        let axisData = new Date().toLocaleTimeString().replace(/^\D*/, '')
        data3.shift()
        data3.push(Math.round(Math.random() * 1000))
        data4.shift()
        data4.push(+(Math.random() * 10 + 5).toFixed(1))
        categories.shift()
        categories.push(axisData)
        categories2.shift()
        categories2.push(count++)
        chart.setOption({
          xAxis: [
            { data: categories },
            { data: categories2 }
          ],
          series: [
            { data: data3 },
            { data: data4 }
          ]
        })
      }, 1800)
      this.timers.push(timer)

      chart.setOption(option)
    },

    // ========== 响应式 ==========
    initResize() {
      this.handleResize = () => {
        Object.values(this.charts).forEach(chart => {
          if (chart && !chart.isDisposed()) {
            chart.resize()
          }
        })
      }
      window.addEventListener('resize', this.handleResize)
      // 容器尺寸变化时自动适配（keep-alive、折叠面板等场景）
      if (typeof ResizeObserver !== 'undefined' && this.$el) {
        this.resizeObserver = new ResizeObserver(() => this.handleResize())
        this.resizeObserver.observe(this.$el)
      }
    }
  }
}
</script>
<style>
@keyframes move_wave {
  0% {
    transform: translateX(0) translateZ(0) scaleY(1)
  }
  50% {
    transform: translateX(-25%) translateZ(0) scaleY(0.55)
  }
  100% {
    transform: translateX(-50%) translateZ(0) scaleY(1)
  }
}
.waveWrapper {
  pointer-events: none;
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.waveWrapperInner {
  pointer-events: none;
  position: absolute;
  width: 100%;
  overflow: hidden;
  height: 100%;
  bottom: -1px;
  /*  background-image: linear-gradient(to top, #86377b 20%, #27273c 80%); */
}
.bgTop {
  z-index: 25;
  opacity: 0.5;
}
.bgMiddle {
  z-index: 20;
  opacity: 0.75;
}
.bgBottom {
  z-index: 15;
}
.wave {
  position: absolute;
  left: 0;
  width: 200%;
  height: 100%;
  background-repeat: repeat no-repeat;
  background-position: 0 bottom;
  transform-origin: center bottom;
}
.waveTop {
  background-image: url('./img/wave-top.png');
  background-size: 50% 100px;
}
.waveAnimation .waveTop {
  animation: move_wave 3s linear infinite;
  -webkit-animation: move_wave 3s linear infinite;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}
.waveMiddle {
  background-image: url('./img/wave-mid.png');
  background-size: 50% 120px;
}
.waveAnimation .waveMiddle {
  animation: move_wave 10s linear infinite;
}
.waveBottom {
  background-image: url('./img/wave-bot.png');
  background-size: 50% 100px;
}
.waveAnimation .waveBottom {
  animation: move_wave 15s linear infinite;
}
</style>

<style scoped>
@import './css/reset.css';
</style>
